import { __awaiter } from "tslib";
/**
 * 订单管理-待买家签署合同
 * @page/OrderManage/WaitSignContract
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { notification } from 'antd';
import { uniqueArr } from '@/shared/functions';
import Mapping from '@/shared/mapping';
const initState = {
    tableData: [],
    totalNumber: 0,
    pageCurrent: 1,
    pageSize: 20,
    contractVisible: false,
    showQrcode: false,
    signBtnLoading: false,
    qrCodeUrl: '',
    contractTitle: '成交确认合同',
    contract: '',
    orderId: '',
    searchData: { // 筛选数据
    // provinceName: '', // 省份名称
    // provinceCode: '', // 省份编号
    // cityName: '', // 城市名称
    // cityCode: '', // 城市编号
    // vinCode: '', // VIN码
    // buyerName: '', // 买方名称
    // sellerCode: '', // 卖方名称
    // buyerPhone: '', // 买方电话
    // sourceType: '', // 成交类型
    // tradeDateStar: '', // 成交起始时间
    // tradeDateEnd: '', // 成交结束时间
    // buyerTypeCode: '', // 买方类型
    // pageCurrent: 1, // 页码
    // pageSize: 20, // 每页条数
    // statusCode: 30, // 查询视图类型
    },
    isLoading: false,
    callback: () => { },
};
export default createStore({
    state: Object.assign({}, initState),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // 充值筛选参数
        RESET_SEARCH_DATA(params) {
            // desc 重置数据
            this.SET_STATE(Object.assign(Object.assign({}, initState), params));
        },
    },
    effects: {
        updateTable(index, { state }) {
            const { searchData, pageCurrent, pageSize } = state;
            console.log(searchData);
            // sellerPhone//卖家经销商电话
            const searchParams = {
                provinceCode: searchData && searchData.provinceCode ? searchData.provinceCode : '',
                cityCode: searchData && searchData.cityCode ? searchData.cityCode : '',
                license: searchData && searchData.license ? searchData.license : '',
                sellerPhone: searchData && searchData.sellerPhone ? searchData.sellerPhone : '',
                vinCode: searchData && searchData.vinCode ? searchData.vinCode : '',
                buyerName: searchData && searchData.buyerName ? searchData.buyerName : '',
                sellerCode: searchData && searchData.sellerCode ? searchData.sellerCode : '',
                buyerPhone: searchData && searchData.buyerPhone ? searchData.buyerPhone : '',
                tradeDateStar: searchData && searchData.startTime ? searchData.startTime : '',
                tradeDateEnd: searchData && searchData.endTime ? searchData.endTime : '',
                buyerTypeCode: searchData && searchData.buyerTypeCode,
                sourceType: searchData && searchData.sourceType,
                pageSize,
                pageCurrent: index ? index : pageCurrent + 1,
            };
            Api.order.getWaitSignList(searchParams).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    totalNumber: res.totalNumber,
                    pageCurrent: res.currentIndex,
                    exportObjParams: Object.assign(Object.assign({}, searchParams), { totalCount: res.totalNumber, exportType: Mapping.excelExportType.order_wait_contract.value }),
                });
            });
        },
        // 获取合同模版数据
        getContract({ orderId, callback }, { state, update }) {
            this.SET_STATE({ orderId, callback });
            Api.order.queryContractConfirmInfo({ orderId }).then((res) => {
                update({ contract: res.previewImgUrl, contractVisible: true });
            });
        },
        // 获取二维码地址
        getQRCode(orderId, { state, update }) {
            Api.order.getSignQRCode({ orderId }).then((req) => {
                update({ qrCodeUrl: req, showQrcode: true });
            });
        },
        // 跳过合同签署
        shipSignContract(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                yield Api.order.skipSignContract({ orderId: payload }).then((res) => {
                    if (res) {
                        notification.success({
                            message: '跳过合同成功',
                        });
                    }
                    else {
                        notification.error({
                            message: '跳过合同失败，请再试一次',
                        });
                    }
                });
            });
        },
        // 关闭成交签署合同并调用回调
        closeSignModal(payload, { update, state }) {
            update({ contractVisible: false, showQrcode: false });
            state.callback();
        },
    },
});
